{
  "neutral_color_class": "text-gray-400 dark:text-gray-500",
  "improvement_color_class": "text-green-600 dark:text-green-400",
  "regression_color_class": "text-red-500 dark:text-red-400",
  "cda_color_threshold": 0.001,
  "watts_color_threshold": 0.05,
  "cda_display_precision": 3
}
